import React, { useEffect } from 'react'
import { SuccessEvent, useFinchConnect } from '@tryfinch/react-connect'
import SegmentService from 'redux/config/services/SegmentService'
import SelectProvidersModal from 'features/Finch/components/SelectProviders'
import Request from 'redux/config/services/Request'

interface ConnectFinchProps {
  onSuccess: (e: SuccessEvent) => void
  open: boolean
  onClose: () => void
}

const FinchConnect = (props: ConnectFinchProps) => {
  // Will this be an issue in the future if the token exchange fails on Finch's end?
  const onSuccess = (e: SuccessEvent) => {
    props.onSuccess(e)
  }

  const onError = ({ errorMessage }) => {
    console.error(errorMessage)
    SegmentService.track('hris-connect-error', {
      msg: errorMessage,
    })
  }
  const onClose = () => SegmentService.track('hris-connect-modal-closed')

  // Finch Connect Setup Documentation: https://developer.tryfinch.com/implementation-guide/Connect/Set-Up-Finch-Connect
  const { open } = useFinchConnect({
    sessionId: undefined,
    onSuccess,
    onError,
    onClose,
  })

  const fetchSession = async (provider: any) => {
    try {
      const response = await Request.post('/finch/session/', {
        products: provider ? provider.products : [],
        provider: provider.id,
      })
      return response.data.sessionId
    } catch (error) {
      console.error('Error creating session:', error)
    }
  }

  const onProviderSelected = async (provider: any) => {
    props.onClose()
    const session = await fetchSession(provider)
    if (session) {
      open({
        sessionId: session,
      })
    } else {
      SegmentService.track('hris-connect-error', {
        msg: 'Error creating session',
      })
    }
  }

  return (
    <SelectProvidersModal
      open={props.open}
      onClose={props.onClose}
      selectProvider={onProviderSelected}
    />
  )
}

export default FinchConnect
